import '../Grid.less';
import React, { FC, ReactNode } from 'react';

interface IProps {
    children?: ReactNode;
}

const CenterColumn: FC<IProps> = ({ children = null }) => (
    <div className="grid__center-column">
        <div className="grid__center-column__inner">{children}</div>
    </div>
);

export default CenterColumn;
